import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { SvgComponent } from '../../../shared/components/svg/svg.component';
import { ButtonDirective } from '../../../shared/directives/button.directive';

@Component({
  selector: 'app-made-with-picflow-button',
  templateUrl: './made-with-picflow-button.component.html',
  styleUrls: ['./made-with-picflow-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ButtonDirective, SvgComponent],
})
export class MadeWithPicflowButtonComponent {
  @Input() tenantId: string;
  @Input() darkBackground: boolean;
}
